import React, { useEffect, useState } from "react";
import { GlobalWorkerOptions, getDocument, version } from "pdfjs-dist";
import _ from "lodash";

GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.worker.min.js`;

type AttachmentPreviewProps = {
  fileUrl: string;
  onClick?: () => void;
};

const isImage = (fileName: string) => /\.(jpg|jpeg|png|gif)$/i.test(fileName);
const isPDF = (fileName: string) => /\.pdf$/i.test(fileName);

// Function to handle PDF thumbnail
const generatePDFThumbnail = async (fileUrl: string) => {
  const loadingTask = getDocument(fileUrl);
  const pdf = await loadingTask.promise;
  const page = await pdf.getPage(1);
  const viewport = page.getViewport({ scale: 0.2 });
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  canvas.width = viewport.width;
  canvas.height = viewport.height;

  if (context) {
    const renderContext = { canvasContext: context, viewport };
    await page.render(renderContext).promise;
    return canvas.toDataURL(); // Convert Canvas to image
  }
  return "";
};

const AttachmentPreview: React.FC<AttachmentPreviewProps> = ({
  fileUrl,
  onClick,
}) => {
  const [thumbnail, setThumbnail] = useState("");

  useEffect(() => {
    const fetchThumbnail = async () => {
      try {
        const _thumbnail = await generatePDFThumbnail(fileUrl);
        setThumbnail(_thumbnail);
      } catch (error) {
        console.error(
          "Erreur lors de la gÃ©nÃ©ration de la miniature PDF :",
          error,
        );
      }
    };
    if (isPDF(fileUrl)) {
      fetchThumbnail();
    }
  }, [fileUrl]);

  if (isImage(fileUrl)) {
    return (
      <img
        src={fileUrl}
        alt="Attachment"
        width={50}
        height={50}
        style={{ cursor: "pointer", marginRight: 10 }}
        onClick={onClick || (() => window.open(fileUrl, "_blank"))}
      />
    );
  }

  if (isPDF(fileUrl)) {
    return (
      <div
        style={{ cursor: "pointer", marginRight: 10 }}
        onClick={onClick || (() => window.open(fileUrl, "_blank"))}
      >
        {thumbnail ? (
          <img src={thumbnail} alt="PDF Thumbnail" width={50} height={50} />
        ) : (
          <div
            style={{
              width: 50,
              height: 50,
              backgroundColor: "#f0f0f0",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#999",
            }}
          >
            PDF
          </div>
        )}
      </div>
    );
  }

  // Other types of files
  return (
    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
      TÃ©lÃ©charger le fichier
    </a>
  );
};

export default AttachmentPreview;
